import { render } from "./BasePageTitleTop.vue?vue&type=template&id=16bd83f7"
import script from "./BasePageTitleTop.vue?vue&type=script&lang=js"
export * from "./BasePageTitleTop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/helpers/BasePageTitleTop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16bd83f7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16bd83f7', __exports__)) {
    api.reload('16bd83f7', __exports__)
  }
  
  module.hot.accept("./BasePageTitleTop.vue?vue&type=template&id=16bd83f7", () => {
    api.rerender('16bd83f7', render)
  })

}


export default __exports__